import { render, staticRenderFns } from "./ColorPalettePanel.vue?vue&type=template&id=63465a4a&scoped=true"
import script from "./ColorPalettePanel.vue?vue&type=script&lang=ts"
export * from "./ColorPalettePanel.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ColorPalettePanel.vue?vue&type=style&index=0&id=63465a4a&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "63465a4a",
  null
  ,true
)

export default component.exports